<div class="bg-mw-quartenary-light flex h-dvh w-full p-6">
  <div class="m-auto w-full max-w-2xl">
    <router-outlet />
  </div>
</div>
